import Flex, { FlexProps } from '@Components/Bases/Flex';
import PdfEngIcon from '@Components/Icons/PdfEngIcon';
import PdfThaiIcon from '@Components/Icons/PdfThaiIcon';
import { CloudDownloadOutlined } from '@mui/icons-material';
import { Button, CircularProgress, Typography } from '@mui/material';

type DownloadButtonProps = {
  label?: string;
  onDownload?: () => void;
  language?: string;
  loading?: boolean;
  disabled?: boolean;
} & Omit<FlexProps, 'ref'>;

const DownloadDocument = (props: DownloadButtonProps) => {
  const { label, onDownload, language, disabled, loading, ...restProps } =
    props;
  return (
    <Flex
      justifyContent={'space-between'}
      alignItems={'center'}
      {...restProps}
      gap={4}
    >
      <Flex gap={1} alignItems={'center'}>
        {language === 'ภาษาไทย' && <PdfThaiIcon />}
        {language === 'ภาษาอังกฤษ' && <PdfEngIcon />}
        <Typography
          sx={{
            fontSize: 16,
            fontWeight: 400,
          }}
        >
          {label} {language}
        </Typography>
      </Flex>

      <Button
        variant="text"
        color="info"
        endIcon={
          loading ? (
            <CircularProgress color="inherit" size={20} />
          ) : (
            <CloudDownloadOutlined />
          )
        }
        onClick={onDownload}
        loading={loading}
        disabled={disabled}
      >
        ดาวน์โหลด
      </Button>
    </Flex>
  );
};

export default DownloadDocument;
